import { render, staticRenderFns } from "./SclerotherapyPage.vue?vue&type=template&id=0296736d&scoped=true"
import script from "./SclerotherapyPage.vue?vue&type=script&lang=js"
export * from "./SclerotherapyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296736d",
  null
  
)

export default component.exports